<script>
import MetisMenu from "metismenujs/dist/metismenujs";

import { menuItems } from "./menu";

export default {
  data() {
    return {
      menuItems: menuItems,
    };
  },
  computed: {
    userType() {
      return this.$store.getters["user/userType"];
    },
    isCityExpressOnly() {
      return this.$store.getters["user/isCityExpressOnly"];
    },
  },
  mounted: function() {
    // eslint-disable-next-line no-unused-vars
    var menuRef = new MetisMenu("#side-menu");
    var links = document.getElementsByClassName("side-nav-link-ref");
    var matchingMenuItem = null;
    const paths = [];

    for (var i = 0; i < links.length; i++) {
      paths.push(links[i]["pathname"]);
    }
    var itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf("/");
      const item = window.location.pathname.substr(0, strIndex).toString();
      matchingMenuItem = links[paths.indexOf(item)];
    } else {
      matchingMenuItem = links[itemIndex];
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add("active");
      var parent = matchingMenuItem.parentElement;

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add("mm-active");
        const parent2 = parent.parentElement.closest("ul");
        if (parent2 && parent2.id !== "side-menu") {
          parent2.classList.add("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add("mm-active");
            var childAnchor = parent3.querySelector(".has-arrow");
            var childDropdown = parent3.querySelector(".has-dropdown");
            if (childAnchor) childAnchor.classList.add("mm-active");
            if (childDropdown) childDropdown.classList.add("mm-active");

            const parent4 = parent3.parentElement;
            if (parent4 && parent4.id !== "side-menu") {
              parent4.classList.add("mm-show");
              const parent5 = parent4.parentElement;
              if (parent5 && parent5.id !== "side-menu") {
                parent5.classList.add("mm-active");
                const childanchor = parent5.querySelector(".is-parent");
                if (childanchor && parent5.id !== "side-menu") {
                  childanchor.classList.add("mm-active");
                }
              }
            }
          }
        }
      }
    }
  },
  methods: {
    /**
     * Determines if a menu item should be displayed based on user type and route metadata
     * @param item menuItem
     */
    shouldShowMenuItem(item) {
      // City-Express-only accounts (e.g. logistika@bigznet.rs) see nothing but
      // the City Express entry, even though they are regular super_admins.
      if (this.isCityExpressOnly) {
        return item.cityExpress === true;
      }
      const baseCondition =
        !item.isTitle &&
        !item.isLayout &&
        item.userTypes.includes(this.userType);
      const aribaCondition =
        this.$route.meta?.isAriba && item.userTypes.includes("ariba");

      return baseCondition || aribaCondition;
    },
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },
    getExternalHref(type) {
      switch (type) {
        case "manual":
          return this.$store.getters["user/userManual"];
        default:
          return "";
      }
    },
  },
};
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->

  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul
      v-if="$route.name !== 'setup'"
      id="side-menu"
      class="metismenu list-unstyled"
    >
      <template v-for="item in menuItems">
        <li
          class="menu-title"
          v-if="
            item.isTitle &&
              !isCityExpressOnly &&
              item.userTypes.includes(userType)
          "
          :key="item.id"
        >
          {{ $t(item.label) }}
        </li>
        <li v-if="shouldShowMenuItem(item)" :key="item.id">
          <a
            v-if="hasItems(item)"
            href="javascript:void(0);"
            class="is-parent"
            :class="{ 'has-arrow': !item.badge, 'has-dropdown': item.badge }"
          >
            <i :class="`${item.icon}`" class="mr-2" v-if="item.icon"></i>
            <span class="font-size-14">{{ $t(item.label) }}</span>
            <span
              :class="
                `badge badge-pill badge-${item.badge.variant} float-right`
              "
              v-if="item.badge"
              >{{ $t(item.badge.text) }}</span
            >
          </a>

          <!-- External Link -->
          <a
            v-if="item.externalLink"
            :href="getExternalHref(item.link)"
            target="_blank"
            rel="noopener noreferrer"
            class="side-nav-link-ref"
          >
            <i :class="`${item.icon}`" class="mr-2" v-if="item.icon"></i>
            <span class="font-size-14">{{ $t(item.label) }}</span>
            <span
              :class="
                `badge badge-pill badge-${item.badge.variant} float-right`
              "
              v-if="item.badge"
              >{{ $t(item.badge.text) }}</span
            >
          </a>

          <!-- Internal Link -->
          <router-link
            :exact="item.link === '/'"
            :to="item.link"
            v-if="!hasItems(item) && item.link && !item.externalLink"
            :class="{ 'btn text-left disabled': false }"
            class="side-nav-link-ref"
          >
            <i :class="`${item.icon}`" class="mr-2" v-if="item.icon"></i>
            <span class="font-size-14">{{ $t(item.label) }}</span>
            <span
              :class="
                `badge badge-pill badge-${item.badge.variant} float-right`
              "
              v-if="item.badge"
              >{{ $t(item.badge.text) }}</span
            >
          </router-link>

          <!-- View only -->
          <a v-if="!hasItems(item) && !item.link && !item.externalLink">
            <i :class="`${item.icon}`" class="mr-2" v-if="item.icon"></i>
            <span class="font-size-14">{{ $t(item.label) }}</span>
            <span
              :class="
                `badge badge-pill badge-${item.badge.variant} float-right`
              "
              v-if="item.badge"
              >{{ $t(item.badge.text) }}</span
            >
          </a>

          <ul v-if="hasItems(item)" class="sub-menu" aria-expanded="false">
            <li v-for="(subitem, index) of item.subItems" :key="index">
              <router-link
                :to="subitem.link"
                v-if="!hasItems(subitem)"
                class="side-nav-link-ref"
                >{{ $t(subitem.label) }}</router-link
              >
              <a
                v-if="hasItems(subitem)"
                class="side-nav-link-a-ref has-arrow"
                href="javascript:void(0);"
                >{{ $t(subitem.label) }}</a
              >
              <ul
                v-if="hasItems(subitem)"
                class="sub-menu mm-collapse"
                aria-expanded="false"
              >
                <li
                  v-for="(subSubitem, index) of subitem.subItems"
                  :key="index"
                >
                  <router-link
                    :to="subSubitem.link"
                    class="side-nav-link-ref"
                    >{{ $t(subSubitem.label) }}</router-link
                  >
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </template>
    </ul>
  </div>
  <!-- Sidebar -->
</template>
